module.exports = __webpack_public_path__ + "static/img/gz_05.b83681f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gz_05.jpg
// module id = MiZ8
// module chunks = 0